import {v4 as UUIDv4} from "uuid";
import {isDefined, notDefined} from "../../libs/utils/epic.utils";

export class AccErrorWrapper {

  public readonly errors: AccError[] = [];

  constructor(init?: Partial<AccErrorWrapper>) {
    Object.assign(this, init);
    if (isDefined(init?.errors)) {
      this.errors = init.errors.map((e) => new AccError(e));
    } else {
      this.errors = [];
    }
  }

  public hasErrors(): boolean {
    return this.errors.length > 0;
  }

  public getErrors(): AccError[] {
    return this.errors;
  }

  public getFirst(): AccError {
    if (this.errors.length > 0) {
      return this.errors[0];
    }
    return new AccError();
  }
}

export class AccError {

  public readonly id!: string;
  public readonly code: string | undefined;
  public readonly messageCode: string | undefined;
  public readonly message: string | undefined;
  public readonly field: string | undefined;

  constructor(init?: Partial<AccError>) {
    Object.assign(this, init);
    if (notDefined(this.id)) {
      this.id = UUIDv4();
    }
  }
}
